export default __webpack_public_path__ + "static/media/google.96d59f6e.png";